// extracted by mini-css-extract-plugin
export default {"container":"InsightsBar_container__6aLD+","navLink":"InsightsBar_navLink__5xsfp"};